module.exports = __webpack_public_path__ + "img/small-remnants.2c4a2366.png";